import React, { useState, useEffect } from "react";

// Icons
import {
  BiDownload,
  BiChevronsRight,
  BiChevronsLeft,
  BiDetail
} from "react-icons/bi";
import { importService } from "../../../../Services/import.service";
import ImportDetailModal from "../../Modals/Import-Detail-modal";

const PaginatedTableImports = (props) => {
  const [initPageIndex, setInitPageIndex] = useState(0);
  const [endPageIndex, setEndPageIndex] = useState(props.pageSize);
  const [paginateIndex, setPaginateIndex] = useState(1);
  const [data, setData] = useState(props.data);
  const [scheduleFileIdDetail, setScheduleFileIdDetail] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const amountPages = () => {
    var division = data.length / props.pageSize;
    var remainder = division % 1;
    var quotient = division - remainder;
    if (remainder > 0) quotient += 1;
    return quotient;
  };

  const onPaginate = (index) => {
    if (index > 0 && index <= amountPages()) {
      setPaginateIndex(index);
      setInitPageIndex(index * props.pageSize - props.pageSize); // 3*10-10 = 20
      setEndPageIndex(index * props.pageSize); // 3*10 = 30
    }
  };

  const onDownload = async (item) => {
    return importService.DownloadFile(item.scheduleFileId, item.fileName);
  };

  const onDetails = async (item) => {
    setScheduleFileIdDetail(item.scheduleFileId);
    setShowDetailModal(true);
    // try {
    //   var details = await importService.fetchDetail(item.scheduleFileId);
    //   if (details) {
    //     setDetailData(details);
    //     setShowDetailModal(true);
    //   }
    // } catch (error) {
    //   console.log("Erro ao buscar detalhes da importação");
    //   console.log(error);
    //   setShowDetailModal(false);
    // }
  };



  const buttons = (item) => {
    return (
      <>
        <div className='row'>
          <div className='col-6'>
            <BiDownload className='icon-button' onClick={async () => onDownload(item)} />
          </div>
          {item.statusId == "error" ? (<>
            <div className='col-6'>
              <BiDetail className='icon-button' onClick={() => onDetails(item)} />
            </div>
          </>) : ("")}
        </div>
      </>
    );
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
  }

  useEffect(() => {

    const initialize = async () => {
      setData(props.data);
    }; initialize();

  }, [props]);

  return (
    <>

      <ImportDetailModal
        show={showDetailModal}
        scheduleFileIdDetail={scheduleFileIdDetail}
        handleClose={handleCloseDetailModal}
      />

      <div className='table-responsive text-nowrap'>
        <table className='table' id='paginated-table'>
          <thead>
            <tr>
              {props.columns &&
                props.columns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              <th>Ações</th>
            </tr>
          </thead>
          <tbody className='table-border-bottom-0'>
            {data &&
              data.map((item, index) =>
                index >= initPageIndex && index < endPageIndex ? (
                  <tr key={index}>
                    {props.fields.map((fields, fieldsIndex) => (
                      <td key={fieldsIndex}>{item[fields]}</td>
                    ))}

                    <td className='action-table-col'>
                      {buttons(item)}
                    </td>
                  </tr>
                ) : (
                  ""
                )
              )}
          </tbody>
        </table>

        <nav aria-label='Page navigation'>
          <ul className='pagination'>
            <li className='page-item'>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex - 1)}>
                <BiChevronsLeft />
              </button>
            </li>

            {data &&
              Array.from({ length: amountPages() }, (_, i) => i + 1).map(
                (item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className={`page-item ${paginateIndex === item ? "active" : ""
                      }`}>
                    <button
                      className='page-link'
                      onClick={() => onPaginate(item)}>
                      {item}
                    </button>
                  </li>
                )
              )}

            <li className='page-item '>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex + 1)}>
                <BiChevronsRight />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};
export default PaginatedTableImports;
